import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import styled from "styled-components";
import { Header2 } from "../components/elements/Header";
import { FormInput, InputLabel } from "../components/elements/Input";
import google from "../assets/svg/google.svg";
import fb from "../assets/svg/facebook.svg";
import {
  Icon,
  LoginFacebook,
  LoginGoogle,
} from "../components/elements/SocialMediaButton";
import Buttons from "../components/elements/Button";
import { useAuth } from "../context/auth";
import { navigate } from "@reach/router";
import { GoogleLogin } from "react-google-login";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

const ForgotPw = styled.p`
  font-family: Poppins;
  color: #fdfffc;
  font-size: 14px;
  text-align: center;
  font-weight: 500;
  text-decoration: underline;
  text-decoration-color: #f89825;
  text-decoration-thickness: 2px;
  cursor: pointer;
`;

const AltSignInText = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  text-align: center;
  letter-spacing: 0.005em;
  color: #fffcf2;
  width: 85%;
  border-bottom: 1px solid #463434;
  line-height: 0.1em;
  margin: 10px 0 20px;
`;

const Span = styled.span`
  background: rgba(4, 3, 3, 0.05);
  padding: 0 10px;
`;

const Error = styled.p`
align-self: stretch;
flex-grow: 0;
font-family: Poppins;
font-size: 11px;
font-weight: normal;
font-stretch: normal;
font-style: normal;
letter-spacing: 0.06px;
text-align: left;
color: #e5333b;
}
`;

const schema = yup.object().shape({
  email: yup.string().required("Please insert your email"),
  password: yup.string().required("Please insert your password"),
});

export default function Login(props) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const { Login, SocialLogin } = useAuth();
  const [credError, setCredError] = useState(false);

  const onSubmit = (data) => {
    Login(data.email, data.password)
      .then(() => {
        navigate("/for-you");
      })
      .catch(() => {
        console.log("failed");
        setCredError(true);
      });
  };

  const onSuccess = (res) => {
    SocialLogin({
      email: res.profileObj.email,
      provider: "google",
      accessToken: res.tokenId,
      id: res.profileObj.googleId,
      fullName: res.profileObj.name,
    }).then((response) => {
      navigate("/for-you");
      return Promise.resolve();
    });
  };

  const responseFacebook = (res) => {
    SocialLogin({
      avatar: res.picture.data.url,
      email: "",
      provider: res.graphDomain,
      accessToken: res.accessToken,
      id: res.id,
      fullName: res.name,
    }).then((response) => {
      props.history.push("for-you");
      return Promise.resolve();
    });
  };

  const onFailure = (res) => {
    console.log("[Login failed]", res);
  };
  return (
    <>
      <div
        style={{ marginTop: "50px", marginBottom: "40px", textAlign: "left" }}
      >
        <Header2>Login</Header2>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <InputLabel>Username:</InputLabel>
        </div>
        <div className="d-flex justify-content-center">
          <div className="d-flex flex-column">
            <FormInput
              {...register("email")}
              placeholder="Your email address"
            />
            <Error>{errors.email?.message}</Error>
          </div>
        </div>

        <div style={{ marginTop: "15px" }}>
          <InputLabel>Password:</InputLabel>
        </div>
        <div className="d-flex justify-content-center">
          <div className="d-flex flex-column">
            <FormInput
              {...register("password")}
              type="password"
              placeholder="Your password"
            />

            <Error>{errors.password?.message}</Error>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          {" "}
          {credError && <Error>wrong email or password</Error>}
        </div>
        <div style={{ marginTop: "40px" }}>
          <Buttons type="submit" mode="Dark" autoWidth={true} types="Primary">
            Login
          </Buttons>
        </div>
        <div style={{ marginTop: "15px" }}>
          <ForgotPw
            onClick={() => {
              navigate("/forgot-password");
            }}
          >
            Forgot password? Reset now.
          </ForgotPw>
        </div>
        <div
          className="d-flex justify-content-center"
          style={{ marginTop: "50px" }}
        >
          <AltSignInText>
            <Span>Or sign in with</Span>
          </AltSignInText>
        </div>
        <div style={{ marginTop: "15px" }}>
          <GoogleLogin
            clientId="698581340258-c8n657fr9dc0igsqbj464rt13rlf81ut.apps.googleusercontent.com"
            buttonText="Sign in with Google"
            onSuccess={onSuccess}
            onFailure={onFailure}
            cookiePolicy={"single_host_origin"}
            isSignedIn={false}
            render={(renderProps) => (
              <LoginGoogle
                onClick={renderProps.onClick}
                disabled={renderProps.disabled}
              >
                <Icon src={google} />
                Sign in with Google
              </LoginGoogle>
            )}
          />
        </div>

        <div style={{ marginTop: "16px", marginBottom: "30px" }}>
          <FacebookLogin
            appId="642867813345546"
            autoLoad={false}
            fields="name,email,picture"
            scope="public_profile,user_friends"
            callback={responseFacebook}
            icon="fa-facebook"
            render={(renderProps) => (
              <LoginFacebook
                onClick={renderProps.onClick}
                disabled={renderProps.disabled}
              >
                <Icon src={fb} />
                Sign in with Facebook
              </LoginFacebook>
            )}
          />
        </div>
      </form>
    </>
  );
}
